module.exports = __webpack_public_path__ + "img/临展数.eef0689a.png";